<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



  
  
document.getElementById('product-sticky-add-to-cart').addEventListener('click', function () {
  console.log('click');
  setTimeout(function () {
    if (document.querySelectorAll('.ymq-error-item').length > 0) {
      var closeButton = document.querySelector('.sticky-product-close.close[data-close-sticky-mobile]');
      if (closeButton) {
        closeButton.click();
      }
    }
  }, 100); // slight delay to allow DOM updates from plugin
});


